import gql from 'graphql-tag';
import { newThemesGQLFields } from './newTheme.fields.js';
export const upsertThemeGQLMutation = (fields) => gql `
  mutation UpsertTheme($input: UpsertTheme!) {
    upsertTheme(input: $input) {
      ${newThemesGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=theme.gql.js.map